import { create } from 'zustand'
import { ReactNode } from 'react'
import { AlertColor } from '@mui/material'

interface SnackbarState {
  open: boolean
  message: string | ReactNode
  severity: AlertColor
  autoHideDuration: number | null
  variant: 'standard' | 'filled' | 'outlined'

  // Actions
  showSnackbar: (
    message: string | ReactNode,
    options?: {
      severity?: AlertColor
      autoHideDuration?: number | null
      variant?: 'standard' | 'filled' | 'outlined'
    },
  ) => void
  hideSnackbar: () => void
}

export const useSnackbarStore = create<SnackbarState>((set) => ({
  open: false,
  message: '',
  severity: 'info',
  autoHideDuration: 6000, // Default 6 seconds
  variant: 'filled',

  showSnackbar: (message, options = {}) =>
    set({
      open: true,
      message,
      severity: options.severity || 'info',
      autoHideDuration: options.autoHideDuration !== undefined ? options.autoHideDuration : 6000,
      variant: options.variant || 'filled',
    }),

  hideSnackbar: () => set({ open: false }),
}))
